import React, { Component } from "react";
import "../../styles/css/ProjectCards/HeaderCard.css";

class FinancialStats extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="headerCardRoot">
        <div className="adminHeaderCardMain fixedStatsHeight">
          <div className="userHeaderCardTitle">
            <span>Financial statistics</span>
            <span> (Under construction)</span>
          </div>
          <div className="adminHeaderCardBody">
            <div className="totalJobStats">
              <div className="statRowExtraMargin highlighted">
                <span>Total transactions</span>
                <span className="">0</span>
              </div>
              <div className="statRowExtraMargin highlighted">
                <span>Total transactions value</span>
                <span className="">0</span>
              </div>
              <div className="statRowExtraMargin highlighted">
                <span>Average individual earning</span>
                <span className="">0</span>
              </div>
              <div className="statRowExtraMargin">
                <span>Pending payment verifications</span>
                <span className="">0</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FinancialStats;



// WEBPACK FOOTER //
// ./src/components/DashboardComponents/FinancialStats.js